import type {UserPropertyADto} from '@cohort/admin-schemas/userProperty';
import ExportUsersAttributeFieldSelect from '@cohort/merchants/apps/brevo/sync/ExportUsersAttributeFieldSelect';
import ExportUsersUserPropertySelect from '@cohort/merchants/apps/brevo/sync/ExportUsersUserPropertySelect';
import type {
  BrevoContactAttribute,
  MappedUserProperty,
} from '@cohort/merchants/apps/brevo/sync/utils';
import Button from '@cohort/merchants/components/buttons/Button';
import {useCohortForm} from '@cohort/merchants/hooks/contexts/form';
import type {SyncConfigFormValues} from '@cohort/merchants/pages/apps/app/utils';
import {ArrowRight, Trash} from '@phosphor-icons/react';
import {useFieldArray} from 'react-hook-form';

interface ExportUsersMappedUserPropertyProps {
  index: number;
  brevoContactAttributes: BrevoContactAttribute[];
  userProperties: UserPropertyADto[] | undefined;
  mappedUserProperty: MappedUserProperty;
}

const ExportUsersMappedUserProperty: React.FC<ExportUsersMappedUserPropertyProps> = ({
  index,
  brevoContactAttributes,
  userProperties,
  mappedUserProperty,
}) => {
  const {control, watch} = useCohortForm<Extract<SyncConfigFormValues, {appId: 'brevo'}>>();

  const mappedUserProperties = watch('userExportConfig.userProperties');

  const {remove: removeUserProperty} = useFieldArray({
    control,
    name: 'userExportConfig.userProperties',
  });

  const handleDeleteField = (index: number): void => {
    removeUserProperty(index);
  };

  const isLoneEmptyUserProperty =
    mappedUserProperties.length === 1 &&
    mappedUserProperties[0]?.brevoAttributeFieldName === '' &&
    mappedUserProperties[0]?.userPropertyId === '';

  return (
    <div key={index} className="flex items-center gap-6">
      <div className="w-[276px]">
        <ExportUsersUserPropertySelect
          index={index}
          brevoContactAttributes={brevoContactAttributes}
          userProperties={userProperties}
          mappedUserProperty={mappedUserProperty}
        />
      </div>
      <ArrowRight size={20} className="text-slate-400" />
      <div className="flex flex-1 items-center">
        <ExportUsersAttributeFieldSelect
          index={index}
          brevoContactAttributes={brevoContactAttributes}
          userProperties={userProperties}
          mappedUserProperty={mappedUserProperty}
        />
      </div>
      <Button
        variant="secondary"
        size="icon"
        onClick={() => handleDeleteField(index)}
        disabled={isLoneEmptyUserProperty}
      >
        <Trash size={20} className="text-red-400" />
      </Button>
    </div>
  );
};

export default ExportUsersMappedUserProperty;
